// src/services/auth.js
import api from './api';

export const login = async (email, senha, nivel, recaptchaToken, id) => {
  try {
    const response = await api.post('/usuarios/login', {
      id,
      email,
      senha,
      nivel,
      recaptchaToken
    });
    localStorage.setItem('token', response.data.token);
    // Armazena 'admin' como o nível. Se não for 'admin', considera 'user'.
    //localStorage.setItem('nivel', response.data.dados.nivel.admin || 'user');
    localStorage.setItem('nivel', response.data.dados.nivel);
    localStorage.setItem('idUser', response.data.dados.id);
    localStorage.setItem('emailUser', response.data.dados.email);
    //return console.log(response.data.dados.email)
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('nivel');
  localStorage.removeItem('idUser');
  localStorage.removeItem('emailUser');
};

export const isAuthenticated = () => {
  return localStorage.getItem('token') !== null;
};

export const getToken = () => {
  return localStorage.getItem('token');
};

export const getUserLevel = () => {
  return localStorage.getItem('nivel');
};

export const getUserId = () => {
  return localStorage.getItem('idUser');
};